import { EndPoints } from "settings/endpoints";
import axiosInstance from "./axios";

export const createProfilePicture = (payload) => {
  return axiosInstance.post(EndPoints.PROFILE_PICTURE.CREATE, payload);
};

export const getEmployeeProfilePicture = (payload) => {
  return axiosInstance.get(EndPoints.PROFILE_PICTURE.LIST_BY_ID, {
    params: { ...payload },
  });
};

export const deleteProfilePicture = (id) => {
  return axiosInstance.delete(
    `${EndPoints.PROFILE_PICTURE.DELETE}?employee_code_id=${id}`
  );
};
